export default function elementInContainer(element, classname, node) {
    if (node === void 0) { node = null; }
    var target = element;
    while (target
        && ![].slice.call(target.classList).includes(classname)) {
        target = target.parentElement;
    }
    if (node) {
        return target === node;
    }
    return !!target;
}
//# sourceMappingURL=element-in-container.js.map